import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, Trash2 } from "lucide-react";
import { useState } from "react";
import { BrandCardHeader } from "#/components/brand/BrandCardHeader";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "#/components/ui/alert-dialog";
import { Button } from "#/components/ui/button";
import { Card, CardContent } from "#/components/ui/card";
import { StatusMessage } from "#/components/ui/status-message";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DeleteAccountCard(t0) {
  const $ = _c(33);
  const {
    handleDelete,
    onBack,
    statusMessage,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const [error, setError] = useState(null);
  let t2;
  if ($[0] !== handleDelete) {
    t2 = async () => {
      try {
        setError(null);
        const response = await handleDelete();
        if (!response.success) {
          setError(response.message);
        }
      } catch {
        setError("Det gick inte att radera kontot. F\xF6rs\xF6k igen senare.");
      }
    };
    $[0] = handleDelete;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleDeleteAccount = t2;
  if (statusMessage) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /*#__PURE__*/_jsx(BrandCardHeader, {
        title: "Ta bort konto",
        subtitle: "Radera ditt konto och all tillh\xF6rande information"
      });
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== statusMessage.message || $[4] !== statusMessage.variant) {
      t4 = /*#__PURE__*/_jsxs(Card, {
        className: "m-auto w-screen overflow-y-auto rounded-none bg-card shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
        children: [t3, /*#__PURE__*/_jsx(CardContent, {
          className: "p-6",
          children: /*#__PURE__*/_jsx(StatusMessage, {
            message: statusMessage.message,
            variant: statusMessage.variant
          })
        })]
      });
      $[3] = statusMessage.message;
      $[4] = statusMessage.variant;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(BrandCardHeader, {
      title: "Ta bort konto",
      subtitle: "Ditt FasterForward-konto anv\xE4nds f\xF6r att bidra till och f\xE5 tillg\xE5ng till verifierad information om tillg\xE4ngliga entr\xE9er."
    });
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== error) {
    t4 = error && /*#__PURE__*/_jsx(StatusMessage, {
      message: error,
      variant: "error"
    });
    $[7] = error;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx("p", {
      children: "Om du tar bort ditt FasterForward-konto s\xE5 raderar vi all information som finns sparad kopplat till ditt konto:"
    });
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-4 text-sm",
      children: [t5, /*#__PURE__*/_jsx("ul", {
        className: "list-inside list-disc space-y-1",
        children: /*#__PURE__*/_jsx("li", {
          children: "ditt namn och kontaktuppgifter"
        })
      })]
    });
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = /*#__PURE__*/_jsx(Trash2, {
      className: "mr-2 h-4 w-4"
    });
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isLoading) {
    t8 = /*#__PURE__*/_jsx(AlertDialogTrigger, {
      asChild: true,
      children: /*#__PURE__*/_jsxs(Button, {
        variant: "destructive",
        className: "w-full",
        disabled: isLoading,
        children: [t7, " Radera konto"]
      })
    });
    $[12] = isLoading;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = /*#__PURE__*/_jsxs(AlertDialogHeader, {
      children: [/*#__PURE__*/_jsx(AlertDialogTitle, {
        children: "Radera konto permanent?"
      }), /*#__PURE__*/_jsx(AlertDialogDescription, {
        children: "Detta g\xE5r inte att \xE5ngra. All din data kommer att raderas permanent."
      })]
    });
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = /*#__PURE__*/_jsx(AlertDialogCancel, {
      className: "sm:mt-0",
      children: "Avbryt"
    });
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = isLoading ? "Raderar..." : "Radera konto";
  let t12;
  if ($[16] !== handleDeleteAccount || $[17] !== isLoading || $[18] !== t11) {
    t12 = /*#__PURE__*/_jsxs(AlertDialogContent, {
      children: [t9, /*#__PURE__*/_jsxs(AlertDialogFooter, {
        className: "flex flex-col-reverse gap-2 sm:flex-row",
        children: [t10, /*#__PURE__*/_jsx(AlertDialogAction, {
          onClick: handleDeleteAccount,
          disabled: isLoading,
          className: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
          children: t11
        })]
      })]
    });
    $[16] = handleDeleteAccount;
    $[17] = isLoading;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t8) {
    t13 = /*#__PURE__*/_jsxs(AlertDialog, {
      children: [t8, t12]
    });
    $[20] = t12;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = /*#__PURE__*/_jsx(ArrowLeft, {
      className: "mr-2 h-4 w-4"
    });
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== isLoading || $[25] !== onBack) {
    t15 = /*#__PURE__*/_jsxs(Button, {
      variant: "outline",
      className: "w-full",
      onClick: onBack,
      disabled: isLoading,
      children: [t14, " Tillbaka"]
    });
    $[24] = isLoading;
    $[25] = onBack;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t15) {
    t16 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t13, t15]
    });
    $[27] = t13;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16 || $[31] !== t4) {
    t17 = /*#__PURE__*/_jsxs(Card, {
      className: "m-auto w-screen overflow-y-auto rounded-none bg-card shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
      children: [t3, /*#__PURE__*/_jsxs(CardContent, {
        className: "space-y-6 p-6",
        children: [t4, t6, t16]
      })]
    });
    $[30] = t16;
    $[31] = t4;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}